var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class SoleProprietorshipCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        this.registrationStatus = checkpoint.registrationStatus;
        this.registrationDate = checkpoint.registrationDate;
        this.status = checkpoint.status;
        this.sector = checkpoint.sector;
        this.numberOfEmployees = checkpoint.numberOfEmployees;
        this.companyName = checkpoint.companyName;
        this.address = checkpoint.address;
    }
    toJson() {
        return {
            registrationStatus: this.registrationStatus,
            registrationDate: this.registrationDate,
            status: this.status,
            sector: this.sector,
            numberOfEmployees: this.numberOfEmployees,
            companyName: this.companyName,
            address: this.address,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.calculateVerificationDate()
        };
    }
}
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "registrationStatus", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "registrationDate", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "status", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "sector", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "numberOfEmployees", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "companyName", void 0);
__decorate([
    observable
], SoleProprietorshipCheckpoint.prototype, "address", void 0);
__decorate([
    action
], SoleProprietorshipCheckpoint.prototype, "toJson", null);
